import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export const useTheme = () => {
  const pathname = useLocation().pathname;

  const getPreferredTheme = () =>
    window.matchMedia &&
    window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";

  const initializeTheme = () => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) return savedTheme;
    const preferredTheme = getPreferredTheme();
    localStorage.setItem("theme", preferredTheme);
    return preferredTheme;
  };

  const [theme, setTheme] = useState(initializeTheme);

  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
  };

  useEffect(() => {
    document.body.className = theme;

    if (
      pathname.includes("admin-dashboard") ||
      pathname.includes("admin-login")
    ) {
      setTheme("light");
    }
  }, [theme]);

  return { theme, toggleTheme, setTheme };
};
